export function BgWrap({ bgImage, children }) {
  if (!bgImage) return <>{children}</>;
  return (
    <>
      <div className="bg-wrap" style={{ backgroundImage: `url(${bgImage})` }} />
      <div className="bg-overlay" />
      <div className="above-bg" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>{children}</div>
    </>
  );
}
